import { CloudOff, Loader2 } from "lucide-react";
import { useOfflineQueue } from "@/hooks/useOfflineQueue";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function OfflineQueueIndicator() {
  const { queueCount, isSyncing, isOnline } = useOfflineQueue();

  if (queueCount === 0 && isOnline) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className="relative flex items-center justify-center h-9 w-9 rounded-md hover:bg-muted transition-colors cursor-default">
          {isSyncing ? (
            <Loader2 className="h-5 w-5 animate-spin text-primary" />
          ) : (
            <CloudOff className="h-5 w-5 text-muted-foreground" />
          )}
          {queueCount > 0 && (
            <span className="absolute -top-0.5 -right-0.5 h-4 w-4 rounded-full bg-orange-500 text-white text-[10px] flex items-center justify-center font-medium">
              {queueCount > 9 ? "9+" : queueCount}
            </span>
          )}
        </div>
      </TooltipTrigger>
      <TooltipContent>
        {isSyncing
          ? "Syncing queued actions…"
          : queueCount > 0
          ? `${queueCount} action${queueCount > 1 ? "s" : ""} queued — will sync when online`
          : "You're offline"}
      </TooltipContent>
    </Tooltip>
  );
}
